import { render, staticRenderFns } from "./OwnerModule.vue?vue&type=template&id=62533ea3&scoped=true&"
import script from "./OwnerModule.vue?vue&type=script&lang=js&"
export * from "./OwnerModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62533ea3",
  null
  
)

export default component.exports